$( document ).ready(function() {
    console.log( "ready!" );
  
    $i = 1;
    $('.page-made-to-measure .multicolumn-list__item').each(function () {
        $delay = $i * 200;
        $(this).attr('data-aos', 'fade-up').attr('data-aos-delay', $delay);
        $i++;
    });

    $('.page-made-to-measure .image-with-text__media').attr('data-aos', 'fade-in').attr('data-aos-delay', 300);

    $('.page-made-to-measure section:last-child').attr('data-aos', 'fade-in').attr('data-aos-delay', 300);

    $('.index main section:nth-of-type(2)').attr('data-aos', 'fade-up').attr('data-aos-delay', 600).attr('data-aos-duration', 800);

    $k = 1;
    $('.index main section:nth-of-type(3) .collection-list__item').each(function () {
        $delay = $k * 400;
        $(this).attr('data-aos', 'fade-up').attr('data-aos-delay', $delay).attr('data-aos-duration', 800);
        $k++;
    });

    $('.index main section:nth-of-type(4) .banner__media').attr('data-aos', 'fade-in').attr('data-aos-delay', 600);

    $('.index .image-with-text__media').attr('data-aos', 'fade-in').attr('data-aos-delay', 600);
  
    AOS.init({
      once: true,
    });

    function scroll(y) {
      var param = (y.offset().top) - 50;
      $('html, body').stop().animate({
          scrollTop: param
      },1000);
    }
    $('.trigger-dest').each(function(){
      $(this).on('click', function(){
        $data = '';
        $data = $(this).data('fibre');
        $('.trigger-dest').removeClass('on');
        $('.fibre-wrapper').slideUp(500);
        setTimeout(function(){
          $('.fibre-container').removeClass('active');
        },400);
        
        if(!$(this).hasClass('on')){
          $(this).addClass('on');
          setTimeout(function(){
            $('#' + $data).addClass('active');
            $('.fibre-wrapper').slideDown(1000);
          },800);
        }
        $box = $('.fibre-section');
        scroll($box);
      });
      
      $('.map-bottom').on('click', function(){
        $box = $('#map');
        scroll($box);
        $('.fibre-wrapper').slideUp(800); 
        setTimeout(function(){
          $('.fibre-container').removeClass('active');
        },500);
      });

      $(this).on('mouseenter', function(){
        $item = $(this).data('fibre');
        $text = $('#' + $item + ' .intro-content span').text();
        $title = $('#' + $item + ' .intro-content h2').text();
        $('.map-fibre span').text($text);
        $('.map-fibre h3').text($title);
        $('.map-fibre').stop().animate({
          opacity: 1,
        }, 300);
      });

      $(this).on('mouseleave', function(){
        $('.map-fibre').stop().animate({
          opacity: 0,
        }, 300);
      });    
    });
});